import React from "react";
import { Sparkle, Search, Target, Send, Megaphone } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: Search,
    title: "Discover",
    body: "We clarify your brand authority, goals, audience, current positioning, and the story that makes your work relevant now.",
  },
  {
    n: "02",
    icon: Target,
    title: "Position",
    body: "We shape your narrative, refine your messaging, and create a media angle designed to resonate with the right audiences and outlets.",
  },
  {
    n: "03",
    icon: Send,
    title: "Pitch",
    body: "We activate targeted outreach across media, podcasts, creators, strategic partners, and visibility channels aligned with your goals.",
  },
  {
    n: "04",
    icon: Megaphone,
    title: "Amplify",
    body: "We help you leverage each opportunity across your website, social channels, newsletters, sales assets, and future campaigns.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-[#080808] py-16 md:py-24 lg:py-32 border-y border-white/5"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        {/* Masthead */}
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-20">
          <div className="col-span-12 md:col-span-3">
            <span className="text-[10px] uppercase tracking-[0.35em] text-[#7FB3D5]">
              ✦ The process
            </span>
            <p className="mt-6 text-[10px] uppercase tracking-[0.3em] text-white/40">
              Page 03
            </p>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2
              data-testid="process-headline"
              className="font-display text-4xl md:text-6xl lg:text-7xl text-white leading-[0.95] tracking-tight font-light"
            >
              From narrative to
              <span className="italic text-[#7FB3D5]"> recognition</span>.
            </h2>
            <p className="mt-6 text-base md:text-lg text-white/65 leading-relaxed max-w-2xl">
              Four deliberate stages built to turn visibility into authority —
              and authority into compounding opportunity.
            </p>
          </div>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <article
                key={s.n}
                data-testid={`process-step-${s.n}`}
                className="group relative bg-[#050505] p-8 md:p-10 hover:bg-[#0a0a0a] transition-colors duration-500 min-h-[340px] flex flex-col"
              >
                <div className="flex items-center justify-between mb-8">
                  <span className="font-display text-4xl md:text-5xl text-white/30 group-hover:text-[#7FB3D5] transition-colors duration-500">
                    {s.n}
                  </span>
                  <div className="w-12 h-12 rounded-full border border-[#7FB3D5]/30 flex items-center justify-center text-[#7FB3D5] group-hover:bg-[#7FB3D5] group-hover:text-black transition-all duration-500">
                    <Icon className="w-5 h-5" strokeWidth={1.2} />
                  </div>
                </div>

                <h3 className="font-display text-3xl md:text-4xl text-white font-light leading-tight">
                  {s.title}
                </h3>

                <p className="mt-5 text-sm md:text-base text-white/65 leading-relaxed">
                  {s.body}
                </p>

                {/* Step connector sparkle on desktop */}
                {i < steps.length - 1 && (
                  <Sparkle
                    className="hidden lg:block absolute -right-2.5 top-1/2 w-4 h-4 text-[#7FB3D5] z-10 bg-[#080808] p-0.5"
                    fill="#7FB3D5"
                    strokeWidth={0.6}
                  />
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
